/**
 * EditViewComponents.js
 *
 * This file provides a central registry for slide type editor components,
 * using dynamic imports to load components only when needed.
 *
 * The keys in this object should match the slide types defined in slideTypes.js
 */

// Component registry with async imports
// From 2025, The component for Editing view of each slide type will be added here
export default {
  'hackathon-slide': () => import('@/components-v2/presentation-editor/side-right/ContentTabHackathon.vue'),
  embed: () => import('@/components-v2/presentation-editor/side-right/EmbedSlideConfig.vue'),
}
